export default __webpack_public_path__ + "static/media/404.3670c965.png";